import { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Modal, Title } from '@g2u/ui-kit';

import { type WithOptionalDataTest } from 'types';
import styles from '../location.module.scss';

type Props = {
  isOpen: boolean;
  onCancel: () => void;
  content: string;
  title: string;
} & WithOptionalDataTest;

export const ServiceScopeModal: FC<Props> = observer((props) => {
  const { isOpen, content, title, onCancel, dataTestId } = props;

  return (
    <Modal.$
      open={isOpen}
      footer={null}
      destroyOnClose
      maskClosable={false}
      onCancel={onCancel}
      title={'Service Working Scope'}
      dataTestId={dataTestId ?? 'service-scope-modal'}
    >
      <Title.$ level={5} className={styles.location__productsSelectScopeTitle}>
        {title}
      </Title.$>
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </Modal.$>
  );
});
